import * as React from 'react';

function SvgPropertyBg(props) {
  return (
    <svg width={472} height={170} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.078 75.262l6.746-9.28 6.071 9.28 6.746-9.28 6.072 9.28 6.746-9.28 6.072 9.28v-51.31h26.984V83.88h87.026v85.179H45.078V75.262z"
        fill="#8AA4A8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.097 106.463h29.265v31.49H16.097v-31.49z"
        fill="#fff"
      />
      <path
        d="M197.537 78.458v2.934h-30.24v-2.934c0-3.829 5.703-10.933 15.12-10.933 9.083 0 15.12 7.104 15.12 10.933z"
        fill="#8AA4A8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.021 95.42H92.958v41.799h40.319v-26.642h-16.256V95.421z"
        fill="#E9E8E6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.654 117.014h3.528v3.782h-3.528v-3.782zm-7.059 0h3.528v3.782h-3.528v-3.782zm17.645 0h-3.528v3.782h3.528v-3.782z"
        fill="#8AA4A8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.116 81.392h3.37v3.782h-3.37v-3.782zm12.806 0h3.37v3.782h-3.37v-3.782zm16.176 0h-3.37v3.782h3.37v-3.782zM92.956 45.157c-1.89 0-2.52 1.891-2.52 1.891v9.455h5.04v-9.455s-.63-1.89-2.52-1.89zm7.561 0c-1.89 0-2.52 1.891-2.52 1.891v9.455h5.04v-9.455s-.63-1.89-2.52-1.89z"
        fill="#B8D9D0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.805 4.469C94.5 3.074 96.043 1.807 96.043 0c0 1.814 1.835 3.1 3.849 4.511 2.448 1.716 5.16 3.616 5.16 6.874 0 2.145-1.085 3.352-2.471 4.019h8.018v6.027h-27.72v-6.027h7.94c-1.352-.673-2.4-1.883-2.4-4.019 0-3.312 2.31-5.21 4.386-6.916z"
        fill="#8AA4A8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.504 95.826h29.568l-10.406 10.779H16.097l10.407-10.78z"
        fill="#FFEDE4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.072 95.826l10.71 10.823v31.136h-21.42v-31.136l10.71-10.823z"
        fill="#E7E7E7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.072 95.826l10.71 10.823h-21.42l10.71-10.823z"
        fill="#F8A588"
      />
      <ellipse cx={182.41} cy={66.891} rx={4.41} ry={1.891} fill="#8AA4A8" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M172.134 116.69h17.847v-1.409h-19.169l1.322 1.409zm-5.288-5.636h23.135v-1.409h-24.457l1.322 1.409zm-5.288-5.636h28.423v-1.409h-29.745l1.322 1.409zm-5.288-5.636h33.711v-1.409h-35.033l1.322 1.41zm-5.288-5.635h38.998v-1.41h-40.32l1.322 1.41z"
        fill="#B8D9D0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 124.914h151.447v8.935h8.962l.007 8.934h8.956l.013 8.935h8.949l.021 8.934h8.941l.028 8.935L0 169.692v-44.778z"
        fill="#FFF8DA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M349.134 153.463a18.777 18.777 0 01-1.898-8.255c0-10.405 8.426-18.84 18.821-18.84 3.833 0 7.398 1.147 10.371 3.116a19.182 19.182 0 0111.205-3.591c8.907 0 16.403 6.045 18.617 14.261.22-.011.44-.017.663-.017 7.352 0 13.312 5.966 13.312 13.326h.001v15.623h-71.154v-15.623h.062z"
        fill="#D8E6E2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M461.356 145.883c5.878 0 10.644 4.77 10.644 10.654v12.492h-56.89v-12.492h.042a15.016 15.016 0 01-1.51-6.583c0-8.32 6.737-15.063 15.048-15.063 3.06 0 5.906.913 8.281 2.483a15.334 15.334 0 018.97-2.88c7.121 0 13.115 4.834 14.885 11.402.175-.009.352-.013.53-.013z"
        fill="#ABD9D0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M342.416 31.234l6.197 19.3h-12.394l6.197-19.3z"
        fill="#8AA4A8"
      />
      <path
        fill="#8AA4A8"
        d="M336.219 51.912h12.395v8.271h-12.395zM332.546 72.13h19.74v96.956h-19.74z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M336.219 61.561h12.394l3.673 9.19h-19.74l3.673-9.19z"
        fill="#8AA4A8"
      />
      <rect x={336.219} y={74.887} width={1.377} height={7.352} rx={0.689} fill="#B8D9D0" />
      <rect x={339.891} y={74.887} width={1.377} height={7.352} rx={0.689} fill="#B8D9D0" />
      <rect x={343.563} y={74.887} width={1.377} height={7.352} rx={0.689} fill="#B8D9D0" />
      <rect x={347.236} y={74.887} width={1.377} height={7.352} rx={0.689} fill="#B8D9D0" />
      <ellipse cx={342.645} cy={92.808} rx={5.968} ry={5.974} fill="#B8D9D0" />
      <path
        fill="#fff"
        d="M303.167 126.625h40.397v2.298h-40.397zM303.167 132.599h40.397v37.22h-40.397z"
      />
      <rect x={307.297} y={136.921} width={1.377} height={23.894} rx={0.689} fill="#B8D9D0" />
      <rect x={313.265} y={136.921} width={1.377} height={23.894} rx={0.689} fill="#B8D9D0" />
      <rect x={319.692} y={136.921} width={1.377} height={23.894} rx={0.689} fill="#B8D9D0" />
      <rect x={325.66} y={136.921} width={1.377} height={23.894} rx={0.689} fill="#B8D9D0" />
      <rect x={332.087} y={136.921} width={1.377} height={23.894} rx={0.689} fill="#B8D9D0" />
      <rect x={338.055} y={136.921} width={1.377} height={23.894} rx={0.689} fill="#B8D9D0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M194.931 157.033a14.967 14.967 0 01-1.465-6.479c0-8.291 6.715-15.013 14.999-15.013 2.944 0 5.691.85 8.008 2.317a15.288 15.288 0 019.185-3.049c7.235 0 13.303 5.006 14.933 11.747.263-.02.529-.03.797-.03 5.737 0 10.41 4.558 10.603 10.253h.007v12.45h-57.067v-12.196z"
        fill="#ABD9D0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M462.01 69.847l.588 11.637a6.955 6.955 0 016.542 6.946 6.959 6.959 0 01-5.248 6.747l.049 2.707h1.991v1.784h-1.959l.013.714h1.946v1.784h-1.914l1.201 66.951h-6.059l.901-66.951h-1.971v-1.784h1.995l.01-.714h-2.005v-1.784h2.029l.038-2.8a6.96 6.96 0 01-4.918-6.654 6.955 6.955 0 016.182-6.915l.589-11.668z"
        fill="#8AA4A8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M298.09 163.258a8.39 8.39 0 01-1.462-4.746c0-4.651 3.767-8.422 8.414-8.422 1.596 0 3.088.445 4.359 1.218a8.734 8.734 0 015.515-1.95c4.093 0 7.532 2.803 8.505 6.597a5.856 5.856 0 016.129 5.852v7.324h-31.46v-5.873z"
        fill="#E4F4F3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M263.702 107.976h13.901l7.317 12.662v48.021h-28.534v-48.021l7.316-12.662z"
        fill="#E9E8E6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M262.808 128.383h3.528v3.782h-3.528v-3.782zm7.056.001h3.529v3.781h-3.529v-3.781zm10.584 0h-3.528v3.781h3.528v-3.781zM230.78 169.957H271.019v-6.87l.001-.087-.001-.088v-.13l-.003-.001a6.953 6.953 0 00-7.71-6.697c-1.202-4.256-4.991-7.365-9.48-7.365-2.702 0-5.151 1.126-6.934 2.951a9.83 9.83 0 00-6.235-2.218c-5.333 0-9.678 4.23-9.871 9.52h-.006v10.985z"
        fill="#8AA4A8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M279.312 134.34h18.86v35.386h-18.86V134.34z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPropertyBg;
